// Shared bits for the Marketplace hub pages.

export const priceLabel = (pricing) => {
  if (!pricing || pricing.model !== "paid") return "FREE";
  const sym = pricing.currency === "INR" ? "₹" : `${pricing.currency || ""} `;
  const per =
    pricing.period === "monthly" ? "/mo"
    : pricing.period === "yearly" ? "/yr"
    : pricing.period === "lifetime" ? " lifetime"
    : "";
  return `${sym}${pricing.amount || 0}${per}`;
};

export const isPaid = (pricing) => pricing?.model === "paid";

// Block copy/cut/context-menu on preview surfaces (marketplace content is
// view-only until installed). Spread onto the preview container element.
export const noCopyProps = {
  onCopy: (e) => e.preventDefault(),
  onCut: (e) => e.preventDefault(),
  onContextMenu: (e) => e.preventDefault(),
  onDragStart: (e) => e.preventDefault(),
};
